// extracted by mini-css-extract-plugin
module.exports = {"slide":"SlideItem_slide__1AzWl","slideImg":"SlideItem_slideImg__v7x3k","slideInfo":"SlideItem_slideInfo__1oOT-","title":"SlideItem_title__3olVF","price":"SlideItem_price__1j-o4"};